import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  structuredData 
}) => {
  useEffect(() => {
    // Removido: window.scrollTo(0, 0); - Esto causaba el scroll automático no deseado
    
    // Update document title
    const defaultTitle = 'RHELMU - Sistema de Gestión Dental';
    const finalTitle = title ? `${title} | ${defaultTitle}` : defaultTitle;
    document.title = finalTitle;
    
    // Update meta description
    const defaultDescription = 'Sistema integral de gestión dental para ortodoncia. Agenda citas, gestiona pacientes, tratamientos y más.';
    const finalDescription = description || defaultDescription;
    
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = finalDescription;
    
    // Update keywords if provided
    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = keywords;
    }
    
    // Update Open Graph tags
    const defaultImage = '/rhelmu-banner.png';
    const defaultUrl = 'https://rhelmu.cl';
    const finalImage = image ? `${defaultUrl}${image}` : `${defaultUrl}${defaultImage}`;
    const finalUrl = url ? `${defaultUrl}${url}` : defaultUrl;
    
    // Update or create Open Graph tags
    const ogTags = [
      { property: 'og:title', content: finalTitle },
      { property: 'og:description', content: finalDescription },
      { property: 'og:image', content: finalImage },
      { property: 'og:url', content: finalUrl },
      { property: 'og:type', content: type },
      { property: 'og:locale', content: 'es_CL' }
    ];
    
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.content = tag.content;
    });
    
    // Update Twitter tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: finalTitle },
      { name: 'twitter:description', content: finalDescription },
      { name: 'twitter:image', content: finalImage }
    ];
    
    twitterTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[name="${tag.name}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.name = tag.name;
        document.head.appendChild(metaTag);
      }
      metaTag.content = tag.content;
    });
    
    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = finalUrl;
    
    // Add structured data if provided
    if (structuredData) {
      let structuredDataScript = document.querySelector('script[data-seo-structured]');
      if (!structuredDataScript) {
        structuredDataScript = document.createElement('script');
        structuredDataScript.type = 'application/ld+json';
        structuredDataScript.setAttribute('data-seo-structured', 'true');
        document.head.appendChild(structuredDataScript);
      }
      structuredDataScript.textContent = JSON.stringify(structuredData);
    }
    
    // Cleanup function
    return () => {
      // Remove dynamic meta tags on unmount if needed
    };
  }, [title, description, keywords, image, url, type, structuredData]);

  return null; // This component doesn't render anything
};

export default SEO;